import { useCallback, useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { useList } from '@redneckz/uni-jsx/lib/hooks/useList';
import { defaultEventBus } from '../../EventBus/defaultEventBus.js';
import { assertUnreachable } from '../../utils/assertUnreachable.js';
export const useDialogsList = ({ onCloseAll, onClose, } = {}) => {
    const [dialogs, { push, pop, clear }] = useList();
    const closeAll = useCallback(() => {
        onCloseAll && onCloseAll(dialogs);
        clear();
    }, [dialogs, onCloseAll]);
    const close = useCallback(() => {
        onClose && onClose(dialogs[dialogs.length - 1]);
        pop();
    }, [dialogs, onClose]);
    useEffect(() => defaultEventBus.subscribe('dialog', (action) => {
        switch (action.type) {
            case 'open':
                push(action);
                break;
            case 'close':
                if (action.all) {
                    closeAll();
                }
                else {
                    close();
                }
                break;
            default:
                assertUnreachable(action);
        }
    }), [closeAll, close]);
    return dialogs;
};
//# sourceMappingURL=useDialogsList.js.map